import baseIcons from '@/shared/assets/sprites/base.sprite.svg';
interface Props {
  rating: number;
  starColor?: string;
}
export const Stars: React.FC<Props> = ({
  rating,
  starColor = 'text-yellow-500'
}) => {
  return <div className="flex items-center gap-1" data-sentry-component="Stars" data-sentry-source-file="stars.tsx">
      {Array.from({
      length: 5
    }).map((_, i) => <div key={i}>
          {i < rating ? <svg className={`size-4 fill-current ${starColor}`}>
              <use xlinkHref={`${baseIcons}#star`}></use>
            </svg> : <svg className={`size-4 fill-none stroke-current stroke-1.5 ${starColor}`}>
              <use xlinkHref={`${baseIcons}#empty-star`}></use>
            </svg>}
        </div>)}
    </div>;
};